module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-error"
  }, [_c('div', {
    staticClass: "page-error-img",
    class: {
      'img-404': _vm.error == 404,
      'img-500': _vm.error != 404
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-error-text"
  }, [(_vm.error == 404) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('general.labels.error')) + " 404")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('error.oops')) + ",")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('error.page_not_exists')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('error.check_url')))])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('general.labels.error')))]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('error.oops')) + ",")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('error.something_wrong')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('error.system_offline')) + _vm._s(_vm.$t('error.our_devs')) + _vm._s(_vm.$t('error.try_again_later')))])])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2b37434e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/ErrorPage.vue
 ** module id = 785
 ** module chunks = 1
 **/